// AI Tools
export const GET_AI_TOOLS_REQUEST = 'GET_AI_TOOLS_REQUEST';
export const GET_AI_TOOLS_SUCCESS = 'GET_AI_TOOLS_SUCCESS';
export const GET_AI_TOOLS_FAILURE = 'GET_AI_TOOLS_FAILURE';

export const GET_AI_TOOL_REQUEST = 'GET_AI_TOOL_REQUEST';
export const GET_AI_TOOL_SUCCESS = 'GET_AI_TOOL_SUCCESS';
export const GET_AI_TOOL_FAILURE = 'GET_AI_TOOL_FAILURE';

export const CREATE_AI_TOOL_REQUEST = 'CREATE_AI_TOOL_REQUEST';
export const CREATE_AI_TOOL_SUCCESS = 'CREATE_AI_TOOL_SUCCESS';
export const CREATE_AI_TOOL_FAILURE = 'CREATE_AI_TOOL_FAILURE';

export const UPDATE_AI_TOOL_REQUEST = 'UPDATE_AI_TOOL_REQUEST';
export const UPDATE_AI_TOOL_SUCCESS = 'UPDATE_AI_TOOL_SUCCESS';
export const UPDATE_AI_TOOL_FAILURE = 'UPDATE_AI_TOOL_FAILURE';

export const DELETE_AI_TOOL_REQUEST = 'DELETE_AI_TOOL_REQUEST';
export const DELETE_AI_TOOL_SUCCESS = 'DELETE_AI_TOOL_SUCCESS';
export const DELETE_AI_TOOL_FAILURE = 'DELETE_AI_TOOL_FAILURE';

export const GET_AI_TOOL_DEFINITION_REQUEST = 'GET_AI_TOOL_DEFINITION_REQUEST';
export const GET_AI_TOOL_DEFINITION_SUCCESS = 'GET_AI_TOOL_DEFINITION_SUCCESS';
export const GET_AI_TOOL_DEFINITION_FAILURE = 'GET_AI_TOOL_DEFINITION_FAILURE';

// AI Tool Generation
export const GENERATE_AI_TOOLS_REQUEST = 'GENERATE_AI_TOOLS_REQUEST';
export const GENERATE_AI_TOOLS_SUCCESS = 'GENERATE_AI_TOOLS_SUCCESS';
export const GENERATE_AI_TOOLS_FAILURE = 'GENERATE_AI_TOOLS_FAILURE';

// AI Tool Execution
export const CALL_AI_TOOL_REQUEST = 'CALL_AI_TOOL_REQUEST';
export const CALL_AI_TOOL_SUCCESS = 'CALL_AI_TOOL_SUCCESS';
export const CALL_AI_TOOL_FAILURE = 'CALL_AI_TOOL_FAILURE';

export const TEST_AI_TOOL_REQUEST = 'TEST_AI_TOOL_REQUEST';
export const TEST_AI_TOOL_SUCCESS = 'TEST_AI_TOOL_SUCCESS';
export const TEST_AI_TOOL_FAILURE = 'TEST_AI_TOOL_FAILURE';

export const RECONCILE_AI_TOOLS_REQUEST = 'RECONCILE_AI_TOOLS_REQUEST';
export const RECONCILE_AI_TOOLS_SUCCESS = 'RECONCILE_AI_TOOLS_SUCCESS';
export const RECONCILE_AI_TOOLS_FAILURE = 'RECONCILE_AI_TOOLS_FAILURE';

// AI Tool Lifecycle (versionless)
export const ACTIVATE_AI_TOOL_REQUEST = 'ACTIVATE_AI_TOOL_REQUEST';
export const ACTIVATE_AI_TOOL_SUCCESS = 'ACTIVATE_AI_TOOL_SUCCESS';
export const ACTIVATE_AI_TOOL_FAILURE = 'ACTIVATE_AI_TOOL_FAILURE';

export const PAUSE_AI_TOOL_REQUEST = 'PAUSE_AI_TOOL_REQUEST';
export const PAUSE_AI_TOOL_SUCCESS = 'PAUSE_AI_TOOL_SUCCESS';
export const PAUSE_AI_TOOL_FAILURE = 'PAUSE_AI_TOOL_FAILURE';

// AI Tool Changelogs (audit trail)
export const GET_AI_TOOL_CHANGELOGS_REQUEST = 'GET_AI_TOOL_CHANGELOGS_REQUEST';
export const GET_AI_TOOL_CHANGELOGS_SUCCESS = 'GET_AI_TOOL_CHANGELOGS_SUCCESS';
export const GET_AI_TOOL_CHANGELOGS_FAILURE = 'GET_AI_TOOL_CHANGELOGS_FAILURE';

// AI Tool Receipts
export const GET_AI_TOOL_RECEIPTS_REQUEST = 'GET_AI_TOOL_RECEIPTS_REQUEST';
export const GET_AI_TOOL_RECEIPTS_SUCCESS = 'GET_AI_TOOL_RECEIPTS_SUCCESS';
export const GET_AI_TOOL_RECEIPTS_FAILURE = 'GET_AI_TOOL_RECEIPTS_FAILURE';

export const GET_AI_TOOL_RECEIPT_REQUEST = 'GET_AI_TOOL_RECEIPT_REQUEST';
export const GET_AI_TOOL_RECEIPT_SUCCESS = 'GET_AI_TOOL_RECEIPT_SUCCESS';
export const GET_AI_TOOL_RECEIPT_FAILURE = 'GET_AI_TOOL_RECEIPT_FAILURE';

export const CREATE_AI_TOOL_RECEIPT_REQUEST = 'CREATE_AI_TOOL_RECEIPT_REQUEST';
export const CREATE_AI_TOOL_RECEIPT_SUCCESS = 'CREATE_AI_TOOL_RECEIPT_SUCCESS';
export const CREATE_AI_TOOL_RECEIPT_FAILURE = 'CREATE_AI_TOOL_RECEIPT_FAILURE';

// AI Tool Packages
export const GET_AI_TOOL_PACKAGES_REQUEST = 'GET_AI_TOOL_PACKAGES_REQUEST';
export const GET_AI_TOOL_PACKAGES_SUCCESS = 'GET_AI_TOOL_PACKAGES_SUCCESS';
export const GET_AI_TOOL_PACKAGES_FAILURE = 'GET_AI_TOOL_PACKAGES_FAILURE';

export const GET_AI_TOOL_PACKAGE_REQUEST = 'GET_AI_TOOL_PACKAGE_REQUEST';
export const GET_AI_TOOL_PACKAGE_SUCCESS = 'GET_AI_TOOL_PACKAGE_SUCCESS';
export const GET_AI_TOOL_PACKAGE_FAILURE = 'GET_AI_TOOL_PACKAGE_FAILURE';

export const CREATE_AI_TOOL_PACKAGE_REQUEST = 'CREATE_AI_TOOL_PACKAGE_REQUEST';
export const CREATE_AI_TOOL_PACKAGE_SUCCESS = 'CREATE_AI_TOOL_PACKAGE_SUCCESS';
export const CREATE_AI_TOOL_PACKAGE_FAILURE = 'CREATE_AI_TOOL_PACKAGE_FAILURE';

export const UPDATE_AI_TOOL_PACKAGE_REQUEST = 'UPDATE_AI_TOOL_PACKAGE_REQUEST';
export const UPDATE_AI_TOOL_PACKAGE_SUCCESS = 'UPDATE_AI_TOOL_PACKAGE_SUCCESS';
export const UPDATE_AI_TOOL_PACKAGE_FAILURE = 'UPDATE_AI_TOOL_PACKAGE_FAILURE';

export const DELETE_AI_TOOL_PACKAGE_REQUEST = 'DELETE_AI_TOOL_PACKAGE_REQUEST';
export const DELETE_AI_TOOL_PACKAGE_SUCCESS = 'DELETE_AI_TOOL_PACKAGE_SUCCESS';
export const DELETE_AI_TOOL_PACKAGE_FAILURE = 'DELETE_AI_TOOL_PACKAGE_FAILURE';

// AI Toolsets
export const GET_AI_TOOLSETS_REQUEST = 'GET_AI_TOOLSETS_REQUEST';
export const GET_AI_TOOLSETS_SUCCESS = 'GET_AI_TOOLSETS_SUCCESS';
export const GET_AI_TOOLSETS_FAILURE = 'GET_AI_TOOLSETS_FAILURE';

export const GET_AI_TOOLSET_REQUEST = 'GET_AI_TOOLSET_REQUEST';
export const GET_AI_TOOLSET_SUCCESS = 'GET_AI_TOOLSET_SUCCESS';
export const GET_AI_TOOLSET_FAILURE = 'GET_AI_TOOLSET_FAILURE';

export const UPDATE_AI_TOOLSET_REQUEST = 'UPDATE_AI_TOOLSET_REQUEST';
export const UPDATE_AI_TOOLSET_SUCCESS = 'UPDATE_AI_TOOLSET_SUCCESS';
export const UPDATE_AI_TOOLSET_FAILURE = 'UPDATE_AI_TOOLSET_FAILURE';

export const DELETE_AI_TOOLSET_REQUEST = 'DELETE_AI_TOOLSET_REQUEST';
export const DELETE_AI_TOOLSET_SUCCESS = 'DELETE_AI_TOOLSET_SUCCESS';
export const DELETE_AI_TOOLSET_FAILURE = 'DELETE_AI_TOOLSET_FAILURE';

// AI Toolset Lifecycle (versionless)
export const ACTIVATE_AI_TOOLSET_REQUEST = 'ACTIVATE_AI_TOOLSET_REQUEST';
export const ACTIVATE_AI_TOOLSET_SUCCESS = 'ACTIVATE_AI_TOOLSET_SUCCESS';
export const ACTIVATE_AI_TOOLSET_FAILURE = 'ACTIVATE_AI_TOOLSET_FAILURE';

export const PAUSE_AI_TOOLSET_REQUEST = 'PAUSE_AI_TOOLSET_REQUEST';
export const PAUSE_AI_TOOLSET_SUCCESS = 'PAUSE_AI_TOOLSET_SUCCESS';
export const PAUSE_AI_TOOLSET_FAILURE = 'PAUSE_AI_TOOLSET_FAILURE';

export const DISABLE_AI_TOOLSET_REQUEST = 'DISABLE_AI_TOOLSET_REQUEST';
export const DISABLE_AI_TOOLSET_SUCCESS = 'DISABLE_AI_TOOLSET_SUCCESS';
export const DISABLE_AI_TOOLSET_FAILURE = 'DISABLE_AI_TOOLSET_FAILURE';

export const ENABLE_AI_TOOLSET_REQUEST = 'ENABLE_AI_TOOLSET_REQUEST';
export const ENABLE_AI_TOOLSET_SUCCESS = 'ENABLE_AI_TOOLSET_SUCCESS';
export const ENABLE_AI_TOOLSET_FAILURE = 'ENABLE_AI_TOOLSET_FAILURE';

// AI Toolset Changelogs (audit trail)
export const GET_AI_TOOLSET_CHANGELOGS_REQUEST = 'GET_AI_TOOLSET_CHANGELOGS_REQUEST';
export const GET_AI_TOOLSET_CHANGELOGS_SUCCESS = 'GET_AI_TOOLSET_CHANGELOGS_SUCCESS';
export const GET_AI_TOOLSET_CHANGELOGS_FAILURE = 'GET_AI_TOOLSET_CHANGELOGS_FAILURE';

// AI Toolset Tool Membership
export const ADD_TOOLS_TO_TOOLSET_REQUEST = 'ADD_TOOLS_TO_TOOLSET_REQUEST';
export const ADD_TOOLS_TO_TOOLSET_SUCCESS = 'ADD_TOOLS_TO_TOOLSET_SUCCESS';
export const ADD_TOOLS_TO_TOOLSET_FAILURE = 'ADD_TOOLS_TO_TOOLSET_FAILURE';

export const REMOVE_TOOLS_FROM_TOOLSET_REQUEST = 'REMOVE_TOOLS_FROM_TOOLSET_REQUEST';
export const REMOVE_TOOLS_FROM_TOOLSET_SUCCESS = 'REMOVE_TOOLS_FROM_TOOLSET_SUCCESS';
export const REMOVE_TOOLS_FROM_TOOLSET_FAILURE = 'REMOVE_TOOLS_FROM_TOOLSET_FAILURE';

// AI Toolset Exports
export const CREATE_AI_TOOLSET_EXPORT_REQUEST = 'CREATE_AI_TOOLSET_EXPORT_REQUEST';
export const CREATE_AI_TOOLSET_EXPORT_SUCCESS = 'CREATE_AI_TOOLSET_EXPORT_SUCCESS';
export const CREATE_AI_TOOLSET_EXPORT_FAILURE = 'CREATE_AI_TOOLSET_EXPORT_FAILURE';

export const GET_AI_TOOLSET_EXPORTS_REQUEST = 'GET_AI_TOOLSET_EXPORTS_REQUEST';
export const GET_AI_TOOLSET_EXPORTS_SUCCESS = 'GET_AI_TOOLSET_EXPORTS_SUCCESS';
export const GET_AI_TOOLSET_EXPORTS_FAILURE = 'GET_AI_TOOLSET_EXPORTS_FAILURE';

export const GET_AI_TOOLSET_EXPORT_REQUEST = 'GET_AI_TOOLSET_EXPORT_REQUEST';
export const GET_AI_TOOLSET_EXPORT_SUCCESS = 'GET_AI_TOOLSET_EXPORT_SUCCESS';
export const GET_AI_TOOLSET_EXPORT_FAILURE = 'GET_AI_TOOLSET_EXPORT_FAILURE';

export const DELETE_AI_TOOLSET_EXPORT_REQUEST = 'DELETE_AI_TOOLSET_EXPORT_REQUEST';
export const DELETE_AI_TOOLSET_EXPORT_SUCCESS = 'DELETE_AI_TOOLSET_EXPORT_SUCCESS';
export const DELETE_AI_TOOLSET_EXPORT_FAILURE = 'DELETE_AI_TOOLSET_EXPORT_FAILURE';

export const UPDATE_AI_TOOLSET_EXPORT_REQUEST = 'UPDATE_AI_TOOLSET_EXPORT_REQUEST';
export const UPDATE_AI_TOOLSET_EXPORT_SUCCESS = 'UPDATE_AI_TOOLSET_EXPORT_SUCCESS';
export const UPDATE_AI_TOOLSET_EXPORT_FAILURE = 'UPDATE_AI_TOOLSET_EXPORT_FAILURE';

export const ACTIVATE_AI_TOOLSET_EXPORT_REQUEST = 'ACTIVATE_AI_TOOLSET_EXPORT_REQUEST';
export const ACTIVATE_AI_TOOLSET_EXPORT_SUCCESS = 'ACTIVATE_AI_TOOLSET_EXPORT_SUCCESS';
export const ACTIVATE_AI_TOOLSET_EXPORT_FAILURE = 'ACTIVATE_AI_TOOLSET_EXPORT_FAILURE';

export const PAUSE_AI_TOOLSET_EXPORT_REQUEST = 'PAUSE_AI_TOOLSET_EXPORT_REQUEST';
export const PAUSE_AI_TOOLSET_EXPORT_SUCCESS = 'PAUSE_AI_TOOLSET_EXPORT_SUCCESS';
export const PAUSE_AI_TOOLSET_EXPORT_FAILURE = 'PAUSE_AI_TOOLSET_EXPORT_FAILURE';

// AI Tool Policies
export const GET_AI_TOOL_POLICIES_REQUEST = 'GET_AI_TOOL_POLICIES_REQUEST';
export const GET_AI_TOOL_POLICIES_SUCCESS = 'GET_AI_TOOL_POLICIES_SUCCESS';
export const GET_AI_TOOL_POLICIES_FAILURE = 'GET_AI_TOOL_POLICIES_FAILURE';

export const GET_AI_TOOL_POLICY_REQUEST = 'GET_AI_TOOL_POLICY_REQUEST';
export const GET_AI_TOOL_POLICY_SUCCESS = 'GET_AI_TOOL_POLICY_SUCCESS';
export const GET_AI_TOOL_POLICY_FAILURE = 'GET_AI_TOOL_POLICY_FAILURE';

export const CREATE_AI_TOOL_POLICY_REQUEST = 'CREATE_AI_TOOL_POLICY_REQUEST';
export const CREATE_AI_TOOL_POLICY_SUCCESS = 'CREATE_AI_TOOL_POLICY_SUCCESS';
export const CREATE_AI_TOOL_POLICY_FAILURE = 'CREATE_AI_TOOL_POLICY_FAILURE';

export const UPDATE_AI_TOOL_POLICY_REQUEST = 'UPDATE_AI_TOOL_POLICY_REQUEST';
export const UPDATE_AI_TOOL_POLICY_SUCCESS = 'UPDATE_AI_TOOL_POLICY_SUCCESS';
export const UPDATE_AI_TOOL_POLICY_FAILURE = 'UPDATE_AI_TOOL_POLICY_FAILURE';

export const DELETE_AI_TOOL_POLICY_REQUEST = 'DELETE_AI_TOOL_POLICY_REQUEST';
export const DELETE_AI_TOOL_POLICY_SUCCESS = 'DELETE_AI_TOOL_POLICY_SUCCESS';
export const DELETE_AI_TOOL_POLICY_FAILURE = 'DELETE_AI_TOOL_POLICY_FAILURE';

// AI Tool Rate Limits
export const GET_AI_TOOL_RATE_LIMITS_REQUEST = 'GET_AI_TOOL_RATE_LIMITS_REQUEST';
export const GET_AI_TOOL_RATE_LIMITS_SUCCESS = 'GET_AI_TOOL_RATE_LIMITS_SUCCESS';
export const GET_AI_TOOL_RATE_LIMITS_FAILURE = 'GET_AI_TOOL_RATE_LIMITS_FAILURE';

export const GET_AI_TOOL_RATE_LIMIT_REQUEST = 'GET_AI_TOOL_RATE_LIMIT_REQUEST';
export const GET_AI_TOOL_RATE_LIMIT_SUCCESS = 'GET_AI_TOOL_RATE_LIMIT_SUCCESS';
export const GET_AI_TOOL_RATE_LIMIT_FAILURE = 'GET_AI_TOOL_RATE_LIMIT_FAILURE';

export const CREATE_AI_TOOL_RATE_LIMIT_REQUEST = 'CREATE_AI_TOOL_RATE_LIMIT_REQUEST';
export const CREATE_AI_TOOL_RATE_LIMIT_SUCCESS = 'CREATE_AI_TOOL_RATE_LIMIT_SUCCESS';
export const CREATE_AI_TOOL_RATE_LIMIT_FAILURE = 'CREATE_AI_TOOL_RATE_LIMIT_FAILURE';

export const UPDATE_AI_TOOL_RATE_LIMIT_REQUEST = 'UPDATE_AI_TOOL_RATE_LIMIT_REQUEST';
export const UPDATE_AI_TOOL_RATE_LIMIT_SUCCESS = 'UPDATE_AI_TOOL_RATE_LIMIT_SUCCESS';
export const UPDATE_AI_TOOL_RATE_LIMIT_FAILURE = 'UPDATE_AI_TOOL_RATE_LIMIT_FAILURE';

export const DELETE_AI_TOOL_RATE_LIMIT_REQUEST = 'DELETE_AI_TOOL_RATE_LIMIT_REQUEST';
export const DELETE_AI_TOOL_RATE_LIMIT_SUCCESS = 'DELETE_AI_TOOL_RATE_LIMIT_SUCCESS';
export const DELETE_AI_TOOL_RATE_LIMIT_FAILURE = 'DELETE_AI_TOOL_RATE_LIMIT_FAILURE';

// AI Tool MCP Config
export const GET_AI_TOOL_MCP_CONFIG_REQUEST = 'GET_AI_TOOL_MCP_CONFIG_REQUEST';
export const GET_AI_TOOL_MCP_CONFIG_SUCCESS = 'GET_AI_TOOL_MCP_CONFIG_SUCCESS';
export const GET_AI_TOOL_MCP_CONFIG_FAILURE = 'GET_AI_TOOL_MCP_CONFIG_FAILURE';

export const REGENERATE_AI_TOOL_MCP_KEY_REQUEST = 'REGENERATE_AI_TOOL_MCP_KEY_REQUEST';
export const REGENERATE_AI_TOOL_MCP_KEY_SUCCESS = 'REGENERATE_AI_TOOL_MCP_KEY_SUCCESS';
export const REGENERATE_AI_TOOL_MCP_KEY_FAILURE = 'REGENERATE_AI_TOOL_MCP_KEY_FAILURE';

export const TEST_AI_TOOL_MCP_CONNECTION_REQUEST = 'TEST_AI_TOOL_MCP_CONNECTION_REQUEST';
export const TEST_AI_TOOL_MCP_CONNECTION_SUCCESS = 'TEST_AI_TOOL_MCP_CONNECTION_SUCCESS';
export const TEST_AI_TOOL_MCP_CONNECTION_FAILURE = 'TEST_AI_TOOL_MCP_CONNECTION_FAILURE';

// AI Compatible Nexsets (for AI Tools section - isolated from main nexset listing)
export const GET_AI_COMPATIBLE_NEXSETS_REQUEST = 'GET_AI_COMPATIBLE_NEXSETS_REQUEST';
export const GET_AI_COMPATIBLE_NEXSETS_SUCCESS = 'GET_AI_COMPATIBLE_NEXSETS_SUCCESS';
export const GET_AI_COMPATIBLE_NEXSETS_FAILURE = 'GET_AI_COMPATIBLE_NEXSETS_FAILURE';
